$(document).on('ready turbolinks:load', function() {
  if ($('#use-reports').length == 0) {
    return;
  }

  $('#use-reports .use-report input[name="use_report[agree_of_term]"]:checkbox').on('click', function() {
    $(this).parents('.use-report').find('input:submit.submit-button').prop('disabled', !$(this).prop('checked'));
  });

  // 利用報告書submitの処理
  //   利用報告書入力画面(use_reports/_form.html.slim)の「提出」
  //   窓口対応者の(提出後)利用報告書(use_reports/_show.html.slim)の「備考更新」
  $('#use-reports .use-report input:submit').on('click', function() {
    const clicked_use_report = $(this).parents('.use-report');

    // クリックした以外の利用日の入力項目を(disabledにすることで)パラメタから除く
    var clicked_reservation_id = clicked_use_report.find('input[name="use_report[reservation_id]"]').val();
    $('#use-reports .use-report').each(function() {
      var reservation_id = $(this).find('input[name="use_report[reservation_id]"]').val();
      if (reservation_id != clicked_reservation_id) {
        $(this).find('[name*="use_report"]').prop('disabled', true);
      }
    });

    $('#use-reports [name=use_report_switch]').prop('disabled', true);

    // 利用報告書を更新するので、RailsのPATCHメソッドとして呼び出す。
    //   PATCH用の入力項目(name: _method): reservations/_reservation_use_report_tab.html.slimにある。
    //   予約の他のタブでの処理に影響しないよう、disabledとして配置しておき、利用報告書で使うときだけ有効にする。
    $('#use-reports input[name="_method"]').prop('disabled', false);

    $(this).trigger('submit');
  });
});
